import React from "react";
import PlusComponent from "../../myComp/PlusComponent";
import PageGrid from "../../myComp/PageGrid";
import Loader from "../../myComp/Loader";

class ActivityGrid extends PlusComponent {
    constructor(props) {
      super(props, "activity");
   
      this.state = {
        grid: null,
      };  
    }
   
    componentDidMount() {
      this.getGrid();
    }
    
    updateGrid(){
      this.getGrid();
    }

    render(){     
        return (
          <div className="main-content">
            <Loader visible={this.state.loadPanelVisible}></Loader>    
            <PageGrid title="Elenco Rapportini" data={this.state.grid} controller="activity" functionality="RAP" eventUpdate={this.updateGrid.bind(this)}></PageGrid>
          </div>
        );
    }     
}

export default ActivityGrid;